export default function EmailIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75932 4.7773C1.75324 4.85078 1.75013 4.92511 1.75013 5.00016V11.0002C1.75013 12.4729 2.94404 13.6668 4.4168 13.6668H13.0835C14.5562 13.6668 15.7501 12.4729 15.7501 11.0002V5.00016C15.7501 4.92511 15.747 4.85078 15.741 4.7773C15.7644 4.63828 15.7441 4.49073 15.6734 4.35633C15.6725 4.35453 15.6715 4.35274 15.6706 4.35096C15.3806 3.19196 14.3323 2.3335 13.0835 2.3335H4.4168C3.16796 2.3335 2.11963 3.19196 1.82972 4.35096C1.82876 4.35274 1.8278 4.35453 1.82686 4.35633C1.75612 4.49073 1.73585 4.63828 1.75932 4.7773ZM3.08347 5.77107V11.0002C3.08347 11.7365 3.68042 12.3335 4.4168 12.3335H13.0835C13.8198 12.3335 14.4168 11.7365 14.4168 11.0002V5.77107L9.37113 8.42669C8.98241 8.63128 8.51786 8.63128 8.12914 8.42669L3.08347 5.77107ZM14.2492 4.35254C14.0215 3.94353 13.5848 3.66683 13.0835 3.66683H4.4168C3.91546 3.66683 3.47875 3.94353 3.25104 4.35254L8.75013 7.2468L14.2492 4.35254Z"
        fill={props.fill || "#0D1126"}
        fillOpacity={props.fillOpacity || "0.4"}
      />
    </svg>
  );
}
